// extracted by mini-css-extract-plugin
module.exports = {"uikit-divider-block":"uikit-divider-block__Z-3HK"};